import React from 'react';
import Section from './Section';
import { useLocale } from 'locale';
import { MapViewWithEvents } from 'components/unit-page/galleryABTests/MapView';
import { ILatLngPoint, InsightDescriptor, InsightType } from 'utils/entities';
import styled from '@emotion/styled';
import { ShowAt, BreakpointValue } from 'consts/breakpoints';


const MapViewWrapper = styled.div<{ height?: number }>`
  width: 100%;
  height: ${({ height }) => (height || 128) + 'px'};
  position: relative;
  border-radius: ${({ theme }) => theme.borderRadius.small};
  border: 2px solid ${({ theme }) => theme.colors.neutrals.white};
  overflow: hidden;
`;

const MapViewOuterWrapper = styled.div`
  border-radius: ${({ theme }) => theme.borderRadius.small};
  border: 1px solid ${({ theme }) => theme.colors.neutrals.grey9};
`;

interface MobileMapWidgetProps {
  locationPoint: ILatLngPoint;
  height?: number;
  hideTitle?: boolean;
  type?: InsightType;
  subType?: InsightDescriptor;
  showTo?: BreakpointValue;
  customMapAction?: () => void;
  withBottomMargin?: boolean;
}

export const MobileMapWidget: React.FC<MobileMapWidgetProps> = ({ locationPoint, customMapAction, showTo, hideTitle, type, subType, height, withBottomMargin = true }) => {
  const { t } = useLocale();
  if (!locationPoint) return null;
  return (
    <ShowAt to={showTo || 2}>
      <Section withBottomMargin={withBottomMargin} heading={hideTitle ? null : t('unitPage.mobileMapWidget.title')}>
        <MapViewOuterWrapper>
          <MapViewWrapper height={height}>
            <MapViewWithEvents lat={locationPoint.lat} customMapAction={customMapAction} lng={locationPoint.lng} withMapAction {...{ type, subType }} />
          </MapViewWrapper>
        </MapViewOuterWrapper>
      </Section>
    </ShowAt>
  );
};
